
import MessageClient from "./MessageClient";
import Helpers from "../../commons/helpers";
import { Constants } from "../../constants/constants";
import { IMultiLanguageContent, IPagedList } from "../../commons/interfaces";



export interface IRequestGetpagedMsg {
    clientId?: string,
    serviceCode: string,
    organizationId?: string,

    byMyself?: number,
    searchText?: string,
    messageType?: number,
    readStatus?: number,
    startTime?: number,
    endTime?: number,
    pageSize: number,
    pageNumber: number,
}

export interface IRecordNotification {
    id: string;
    clientId: string;
    tenantCode: string;
    serviceCode: string;
    organizationId: string;

    type: number;
    titleValue: string;
    contentValue: string;
    title: IMultiLanguageContent;
    content: IMultiLanguageContent;

    to: string;
    cc: string;
    bcc: string;
    from: string;

    sendStatus: number;
    sendTime: string;
    retryCount: number;
    unSendList: string;
    requestId: string;
    requestType: number;
    readStatus: number;

    status: number;
    createTime: string;
    createUser: string;
    updateTime: string;
    updateUser: string;
}

export interface IUserMessageResponse {
    id?: string;
    status: number;
    messageId?: string;
    userId?: string;
    readStatus?: number;
    unSent?: string;
    user?: UserInfoResponse;
}

export interface UserInfoResponse {
    fullName?: string;
    email?: string;
    avartarId?: string;
    avatarUrl?: string;
    identityId?: string;
    phoneNumber?: string;
}

export interface IMsgTargetReponse {
    users: IUserMessageResponse[]
    groupIds: string[]
}

export interface IDataDetailMsg {
    clientId: string
    tenantCode: string
    serviceCode: string
    organizationId: string
    titleValue: any
    contentValue: any
    readStatus: number
    toResponse: IMsgTargetReponse
    ccResponse: IMsgTargetReponse
    bccResponse: IMsgTargetReponse
    type: number
    from: any
    to: any
    cc: any
    bcc: any
    title: IMultiLanguageContent
    content: IMultiLanguageContent
    sendTime: number
    sendStatus: number
    retryCount: number
    requestId: any
    redirectUrl: any
    requestType: number
    id: string
    status: number
    createTime: string
    createUser: string
    updateTime: string
    updateUser: string
};

export interface ISendUsers {
    userId: string,
    email: string,
    phoneNumber: string,
}

export interface IDateCreateMsg {
    clientId: string,
    organizationId: string,
    type: number,
    from: string,
    sendTime: number,
    realTime: boolean,
    requestId: string,
    requestType: number,
    redirectUrl: string,
    title: IMultiLanguageContent,
    content: IMultiLanguageContent,
    sendUsers: {
        type: number,
        sendUsers: ISendUsers[]
    }[],
    groups: {
        type: number,
        groupIds: string[]
    }[],
}

const NotificationService = {
    registerFirebase: async (data: {
        deviceId: string,
        deviceInfo: string
    }) => {
        const result = await MessageClient().post(
            Constants.ApiPath.NOTIFICATION.REGISTER,
            data,
        );
        return result.data;
    },

    unRegisterFirebase: async (deviceId: any) => {
        const result = await MessageClient().delete(
            `${Constants.ApiPath.NOTIFICATION.UN_REGISTER}/${deviceId}`
        );
        return result.data;
    },

    getPaged: async (data: IRequestGetpagedMsg): Promise<{
        unReadTotal?: number;
        pageValue: IPagedList<IRecordNotification>;
    }> => {
        const params = Helpers.handleFormatParams(data);
        const result = await MessageClient().get(
            `${Constants.ApiPath.NOTIFICATION.GET_PAGED}?${params}`
        );
        return result.data.result;
    },

    getDetailNotification: async (messageId: string): Promise<IDataDetailMsg> => {
        const result = await MessageClient().get(
            `${Constants.ApiPath.NOTIFICATION.DETAIL_MESSAGE}/${messageId}`
        );
        return result.data.result;
    },

    readAllNotification: async (clientId: string) => {
        const result = await MessageClient().post(
            Constants.ApiPath.NOTIFICATION.READ_ALL_MESSAGE,
            { clientId: clientId },
        );
        return result.data;
    },

    readNotificationById: async (messageId: string) => {
        const result = await MessageClient().post(
            `${Constants.ApiPath.NOTIFICATION.READ_MESSAGE}/${messageId}`
        );
        return result.data;
    },

    createNotifi: async (data: IDateCreateMsg) => {
        const result = await MessageClient().post(
            `${Constants.ApiPath.NOTIFICATION.CREATE}`,
            data,
        )
        return result.data.result;
    },

    deleteAllNotification: async () => {
        const result = await MessageClient().delete(
            Constants.ApiPath.NOTIFICATION.DELETE_ALL_MESSAGE
        )
        return result.data;
    },

}

export default NotificationService